import React, { Component } from 'react';
import ChildList from './List';
import ChildFilter from './Filter';

class ChooseChild extends Component {

	componentDidMount() {
		const { pagination, onLoadChildren, onInitializeFilter } = this.props;
		const { filter, sortKey, sortDirection, pageNumber, pageSize,  } = pagination;
		onLoadChildren({ filter, sortKey, sortDirection, pageNumber, pageSize });
		onInitializeFilter(filter);
	}

	render() {
		const { t, onFilterChildren, onResetChildFilter, onSelectChild, data, pagination, onChildListEvent } = this.props;
		return (
			<div>
				<ChildFilter onSubmit={onFilterChildren} onReset={onResetChildFilter} />
				<ChildList t={t} data={data} {...pagination} onSelectChild={onSelectChild} onFetchData={onChildListEvent} />
			</div>
		);
	}

};

export default ChooseChild;